(function () {
  'use strict';

  angular
    .module('chat')
    .config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {
    $stateProvider
      .state('chat', {
        url: '/chat',
        templateUrl: 'chat/chat.tpl.html',
        controller: 'ChatCtrl',
        controllerAs: 'chat'
      });
  }
}());
